import ContentLoader from '@cobliteam/base-components/src/ContentLoader/ContentLoader';

const Skeleton = () => {
  return (
    <ContentLoader data-testid='filter-skeleton' width={100} height={30}>
      <rect x='0' y='0' width='100' height='30' />
    </ContentLoader>
  );
};

export default Skeleton;
